import GerenciamentoParametrosViewModel from "@/shared/view-models/GerenciamentoParametrosViewModel";
import AccountLoged from "@/shared/mixins/AccountLoged";
import RepresentanteController from "@/shared/controllers/representante/representanteController";


const name = 'GerenciamentoParametros'
export default {
  name,

  components: { }, 
  mixins:[AccountLoged],

  props: { },

  mounted () {
    if(!this.hasClaim('Gerenciamento-Parâmetros')) {
      this.$router.push('/sem-acesso')
    }
    this.getSistema()
    this.getNomeGrupo()
   },

  updated () { },

  data () {
    return { 
      carregandoEnvioRepresentatesCrm:false,
      logs:null,
      habilitar:null,
      numeroSenha: null,
      numeroTentativas: null,
      numeroLimpezaLog: null,
      nomeGrupo: null,
      grupoArray:[],
      GrupoSelecionado: [],
      GruposSelecionados: [],
      novoGerenciamentoParametros : new GerenciamentoParametrosViewModel()
    }
  },

  methods: {
    async enviarRepresentanteCRM(){
      this.carregandoEnvioRepresentatesCrm = true
      const errorToast = { severity: 'error', summary: 'Não foi possível fazer o envio dos represntantes ao crm', life: 3200 }
      
      await RepresentanteController.enviarRepresentanteCRM().requisicao.then((r)=>{
        if(r.data.code == 200){
          this.$toast.add({ severity: 'success', summary: 'Os Representantes foram enviados ao crm com exito', life: 3200 });
        }else{
          this.$toast.add(errorToast);
        }
      }).catch(()=>{
        this.$toast.add(errorToast);
      }).finally(()=> this.carregandoEnvioRepresentatesCrm = false)
    },

    getSistema() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API + 
          `SistemaParametros/GetSistemaParametros`,
      })
        .then((response) => {

          this.novoGerenciamentoParametros.id = response.data.data.id
          this.novoGerenciamentoParametros.numeroSenha = response.data.data.numeroDiasTrocaSenha;
          this.novoGerenciamentoParametros.numeroTentativas = response.data.data.numeroMaximoTentativas;
          this.novoGerenciamentoParametros.numeroDiasLimpezaLog = response.data.data.numeroDiasLimpezaLog;
          this.novoGerenciamentoParametros.tapumeAtivo = response.data.data.tapumeAtivo;

          this.getNomeGrupo()
          this.GruposSelecionados = response.data.data.gruposIsentos;


          

        })
        .catch(() => {});
    },


    getNomeGrupo() {
      this.axios ({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API + 
          `SistemasParametros/GetNomeGrupo`,
        data: {
          id: this.novoGerenciamentoParametros.nomeGrupo
        }
      })
        .then((response) => {
          this.grupoArray = response.data.data
        })
        .catch(() => {});
    },

  updateParametros() {

      this.axios ({
        method: "put", 
        url:
        process.env.VUE_APP_WEB_API + 
        `SistemasParametros/UpdateParametros`,
        data: {
          NumeroDiasTrocaSenha: this.novoGerenciamentoParametros.numeroSenha,
          NumeroMaximoTentativas: this.novoGerenciamentoParametros.numeroTentativas,
          NumeroDiasLimpezaLog: this.novoGerenciamentoParametros.numeroDiasLimpezaLog,
          TapumeAtivo: this.novoGerenciamentoParametros.tapumeAtivo,
          Id: this.novoGerenciamentoParametros.id,
          gruposIsentos: this.GruposSelecionados
        }
      })
        .then((response) => {
          response
            this.$toast.add({severity:'success', summary: 'Dados alterados com sucesso', detail:'Seus dados foram alterados', life: 5000});
        })
        .catch(() => {});
    },

   },

  computed: { }, 

};